export default __webpack_public_path__ + "158debf0a94d7f4b7fcc3c3746c67157.png";